var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};

module.exports = {
  metaData: {
    "default": {
      title: function(d) { return " إدارة الحساب  | THE OUTNET"; },
      description: function(d) { return "خصم يصل إلى 70% على أكثر من 350 علامة تجارية. انخفض كلّ شيء إلّا مستوى الحماس"; },
      keywords: function(d) { return "تتوفر خدمة التوصيل في اليوم الثاني  لأكثر العلامات التجارية أناقة  وكل ما يصلنا من تصميمات جديدة  على موقعنا أسبوعيًا. على جميع الطلبات التي تبلغ أكثر من  300 جنيه إسترليني شحن سريع مجاني العلامات التجارية: Tory Burch, Alexander Wang, Dolce & Gabbana, Isabel Marant, Emilio Pucci."; }
    }
  },
  languages: {
    en: function(d) { return "English"; },
    ar: function(d) { return "اللغة العربية"; },
    de: function(d) { return "Deutsche"; },
    fr: function(d) { return "Française"; },
    ja: function(d) { return "Japanese"; },
    ko: function(d) { return "Korean"; }
  },
  titles: {
    mr: function(d) { return "السيد"; },
    ms: function(d) { return "حضرة"; },
    mrs: function(d) { return "السيدة"; },
    miss: function(d) { return "الآنسة\t"; },
    sir: function(d) { return "أفندي\t"; },
    dr: function(d) { return "الدكتور"; },
    lord: function(d) { return "اللورد"; },
    prof: function(d) { return "الأستاذ"; },
    rev: function(d) { return "السيد الموقر"; },
    other: function(d) { return "أخرى"; }
  },
  menu: function(d) { return "القائمة"; },
  pages: {
    myAccountLanding: {
      title: function(d) { return "حسابك"; },
      description: function(d) { return ""; }
    },
    preferences: {
      title: function(d) { return "تفضيلات التسويق"; },
      description: function(d) { return " يُرجى استقبال رسائل البريد الإلكتروني منا"; }
    },
    myorders: {
      title: function(d) { return "طلبيّاتي"; },
      description: function(d) { return " تتبعوا واستعرضوا طلبياتكم أو قوموا بطلب إرجاع"; }
    },
    savedcards: {
      title: function(d) { return "البطاقات المحفوظة"; },
      description: function(d) { return "عرض وإدارة طرق الدفع"; }
    },
    orderdetails: {
      title: function(d) { return "تفاصيل الطلبيّة"; },
      description: function(d) { return "عرض تفاصيل الطلبية"; }
    },
    wishlist: {
      title: function(d) { return "قائمة الأمنيات"; },
      description: function(d) { return "يُرجى الاحتفاظ بالقطع"; }
    },
    addressBook: {
      title: function(d) { return "دفتر العناوين"; },
      description: function(d) { return "إدارة عنوانك"; }
    },
    accountdetails: {
      title: function(d) { return "تفاصيل الحساب"; },
      description: function(d) { return "يُرجى تغيير معلومات تسجيل الدخول الخاصة بك"; }
    },
    accountDetailsForm: {
      title: function(d) { return "نموذج تفاصيل الحساب"; },
      description: function(d) { return "نموذج لتحديث قسم تفاصيل الحساب"; }
    },
    privacy: {
      title: function(d) { return "إعدادات الخصوصية"; },
      description: function(d) { return "عرض وإدارة إعدادات الخصوصية"; }
    },
    managecards: {
      title: function(d) { return "إدارة البطاقات "; },
      description: function(d) { return "عرض وتحديث معلومات الدفع المحفوظة"; }
    },
    orderdetailsReturn: {
      title: function(d) { return "القطع المرتجعة"; },
      description: function(d) { return ""; }
    },
    guestorderdetails: {
      title: function(d) { return ""; },
      description: function(d) { return ""; }
    },
    referAFriend: {
      title: function(d) { return "اذكر صديقًا"; },
      description: function(d) { return "اقترح موقع THE OUTNET  على أصدقاءك واحصل على العديد من الجوائز"; },
      cta: function(d) { return "ابدأ"; }
    },
    credits: {
      title: function(d) { return "قسيمة مشتريات من المتجر"; },
      description: function(d) { return "رصيدك ومن معاملاتك"; }
    }
  },
  myAccountLanding: {
    title: function(d) { return "أهلا بك في حسابك "; },
    pageError: function(d) { return "عذرًا، حدث خطئ ما "; },
    retryNow: function(d) { return " يُرجى إعادة المحاولة الآن"; }
  },
  address: {
    primaryInfo: function(d) { return "تلقائيا " + select(d.type, { both: "shipping & billing", shipping: "shipping", billing: "billing", other: "" }) + " العنوان"; }
  },
  addressBook: {
    title: function(d) { return "دفتر العناوين"; },
    editTitle: function(d) { return " يُرجى تعديل العنوان"; },
    addTitle: function(d) { return "يُرجى إضافة عنوان جديد"; },
    "delete": function(d) { return "حذف"; },
    undo: function(d) { return "تراجع"; },
    edit: function(d) { return "تعديل"; },
    deleted: function(d) { return "قمت بحذف العنوان:"; },
    saved: function(d) { return select(d.type, { update: " قُمت بتحديث العنوان: " + d.addressLine, other: "تم بنجاح - قُمت بإضافة عنان جديد: " + d.addressLine }); },
    description: function(d) { return "إدارة عنوانك"; },
    addAddressLink: function(d) { return "يُرجى إضافة عنوانك"; },
    deleteError: function(d) { return "حدث خلل أثناء حذف العنوان"; },
    emptyAddressesTitle: function(d) { return "ليس لديك أي عناوين محفوظة"; },
    emptyAddressesDetails: function(d) { return " يُرجى إضافة عنوان لتسريع عملية الدّفع"; },
    emptyAddressLinkTitle: function(d) { return "أضف عنوان"; },
    pageError: function(d) { return "عذرًا، حدث خطئ ما"; },
    retryNow: function(d) { return "يُرجى إعادة المحاولة الآن"; }
  },
  addressForm: {
    save: function(d) { return "حفظ"; },
    select: function(d) { return "اختيار " + d.select; },
    display: {
      city: function(d) { return "المدينة"; },
      country: function(d) { return "الدولة"; },
      personTitle: function(d) { return "اللقب"; },
      firstName: function(d) { return "الاسم الأول"; },
      lastName: function(d) { return "اسم العائلة"; },
      addressLine_1: function(d) { return "سطر العنوان الأول"; },
      addressLine_2: function(d) { return "سطر العنوان الثاني"; },
      cityTownVillage: function(d) { return "المدينة، البلدة، القرية"; },
      streetName: function(d) { return "اسم الشارع"; },
      buildingName: function(d) { return "اسم البناء"; },
      district: function(d) { return "الحي"; },
      county: function(d) { return "البلد "; },
      pronunciationFirstName: function(d) { return "لفظ الاسم الأول"; },
      pronunciationLastName: function(d) { return "لفظ اسم العائلة"; },
      phone: function(d) { return "رقم الهاتف"; },
      alternatePhone: function(d) { return "رقم بديل"; },
      province: function(d) { return "المحافظة"; },
      state: function(d) { return "الولاية"; },
      region: function(d) { return "الإقليم"; },
      area: function(d) { return "المنطقة"; },
      zipCode: function(d) { return "الرمز البريدي"; },
      postCode: function(d) { return "الرقم البريدي"; },
      eircode: function(d) { return "Eircode"; },
      pccc: function(d) { return "رمز التخليص الجمركي الشخصي"; }
    },
    help: {
      pccc: function(d) { return " يُرجى إدخال رقم التخليص الجمركي الخاص بك مثال ( P+ اثنا عشر مدخلة)"; },
      Eircode: function(d) { return "e.g. A65 F4E2"; }
    }
  },
  accountDetails: {
    title: function(d) { return "تفاصيل الحساب"; },
    fullName: function(d) { return d.firstName + " " + d.lastName; },
    description: function(d) { return " يُرجى تغيير معلومات تسجيل الدخول الخاصة بك"; },
    personalInfo: function(d) { return "تغيير المعلومات الشخصية"; },
    email: function(d) { return " البريد الإلكتروني"; },
    dob: function(d) { return "وُلِدتُ في " + d.dob; },
    password: function(d) { return "كلمة المرور"; },
    passwordDots: function(d) { return "●●●●●●●●●●●●"; },
    edit: function(d) { return "تعديل"; },
    cancel: function(d) { return "إلغاء"; },
    updated: function(d) { return "تم تحديث كل من " + select(d.updateUserSuccess, { personalInfo: "الملعومات الشخصية", changeEmail: "البريد الإلكتروني", changePassword: "كلمة المرور", other: "المعلومات" }) + " بنجاح."; },
    pageError: function(d) { return "نعتذر، حدث خطئ ما."; },
    retryNow: function(d) { return " يُرجى إعادة المحاولة الآن"; }
  },
  returnsAndExchangesForm: {
    exchangeLabel: function(d) { return "التبديل "; },
    returnLabel: function(d) { return "الإرجاع"; },
    reasonLabel: function(d) { return " نرجو إخبارنا عن السبب"; },
    selectReasonReturn: function(d) { return "يُرجى اختيار السبب"; },
    selectReasonExchange: function(d) { return "يُرجى اختيار السبب"; },
    sizesAndColoursTitle: function(d) { return "يُرجى اختيار مقاس آخر"; },
    colourLabel: function(d) { return "اللون"; },
    sizeLabel: function(d) { return "المقاس"; },
    submit: function(d) { return "استمرار"; },
    other: function(d) { return "أخرى..."; },
    requiredReturnCode: function(d) { return "يُرجى اختيار سبباً"; },
    requiredReturnNote: function(d) { return "تُعتبر ملاحظة سبب الإرجاع إلزامية "; },
    requiredSize: function(d) { return "يُعتبر خيار تحديد المقاس إلزاميّا"; },
    requiredReturnType: function(d) { return "يُعتبر نوع الإرجاع إلزاميّا"; },
    refundLabel: function(d) { return "اُفضّل استعادة المبلغ المالي"; }
  },
  refundForm: {
    termsAndConditionsError: function(d) { return "يُرجى الموافقة على الشروط والأحكام للاستمرار"; },
    conditionsTitle: function(d) { return "شروط الإرجاع"; },
    conditions: function(d) { return "يُرجى التأكد من إرجاع القطع بحالة جديدة، غير مستعملة، مع البطاقات مرفقةٌ بها"; },
    termsAndConditions: function(d) { return "اُقرّ بأنني قرأت سياسة الإرجاع لدى The Outnet وأوافق عليها"; },
    seeMore: function(d) { return "اكتشاف المزيد"; },
    submit: function(d) { return "التأكيد"; },
    refundMethodTitle: function(d) { return "طريقة استرجاع المال المفضلة "; },
    refundCard: function(d) { return "استرجاع المال على البطاقة الائتمانية/ بطاقة الخصم"; },
    refundCardInfo: function(d) { return select(d.showStoreCreditFirst, { true: ". يمكن أن يستغرق إرجاع المبالغ حتى 10 أيام عمل لتظهر في حسابكَ، وذلك حسب جهة إصدار الدفع الخاصة بكَ", other: "سيتم إرجاع الأموال بنفس طريقة الدفع الأصلية التي اخترتها" }); },
    refundAsCharged: function(d) { return "طريقة الدفع الأصلية"; },
    refundAsChargedInfo: function(d) { return select(d.showStoreCreditFirst, { true: "يمكن أن يستغرق إرجاع المبالغ حتى 10 أيام عمل لتظهر في حسابكَ، وذلك حسب جهة إصدار الدفع الخاصة بكَ", other: "سيتم إرجاع الأموال بنفس طريقة الدفع الأصلية التي اخترتها" }); },
    storeCredit: function(d) { return "استرداد المبلغ كرصيد في الحساب الشخصي على الموقع"; },
    storeCreditInfo: function(d) { return select(d.showStoreCreditFirst, { true: "سيتم إرجاع المبلغ كرصيد في حسابكَ الشخصي لدى The Outnet بمجرد معالجة عملية الإرجاع", other: "صالح لمدة 12 شهر من تاريخ إرجاع المبلغ" }); },
    storeCreditBanner: function(d) { return "طريقة استرداد سريعة"; }
  },
  colourAndSize: {
    colour: function(d) { return "اللون"; },
    moreColours: function(d) { return "+المزيد"; }
  },
  sizes: {
    sizeLabel: function(d) { return "المقاس"; },
    initialValue: function(d) { return "اختر المقاس"; },
    oneSizeLabel: function(d) { return "يُرجى اختيار المقاس"; },
    viewSizeGuide: function(d) { return "دليل المقاسات"; },
    sizeGuide: {
      viewSizeGuide: function(d) { return " هل تحتاجون المساعدة في إيجاد مقاسكم؟ اطّلعوا على <u> دليل المقاسات لدينا </u>"; },
      title: function(d) { return "دليل المقاسات"; }
    }
  },
  considered: {
    badge: function(d) { return "الاستدامة"; }
  },
  changeEmailForm: {
    currentEmail: function(d) { return "عنوان البريد الإلكتروني الحالي"; },
    newEmail: function(d) { return "عنوان البريد الإلكتروني الجديد"; },
    password: function(d) { return "كلمة المرور الحالية"; },
    update: function(d) { return "تحديث"; }
  },
  changePasswordForm: {
    currentPassword: function(d) { return "كلمة المرور الحالية"; },
    newPassword: function(d) { return "كلمة المرور الجديدة"; },
    confirmPassword: function(d) { return "تأكيد كلمة المرور الجديدة"; },
    update: function(d) { return "تحديث كلمة المرور "; },
    passwordRequirements: function(d) { return "استخدم  8 رموز على الأقل استخدم حرفًا كبيرا ورقمًا"; }
  },
  loginAndRegistrationForm: {
    hasAccountTitle: function(d) { return "أهلاً بك"; },
    hasAccountSubTitle: function(d) { return "يُرجى إدخال بريدك الإلكتروني."; },
    noAccountTitle: function(d) { return "يُرجى التسجيل الآن"; },
    noAccountSubTitle: function(d) { return "يُرجى تجهيز حسابًا لتجربة تسوّق أسهل"; },
    logonId: function(d) { return " البريد الإلكتروني"; },
    hasAccount: function(d) { return "أنا مُسجّل مسبقًا"; },
    noAccount: function(d) { return "أنا جديدٌ  في The Outnet"; },
    forgotPassword: function(d) { return ""; },
    forgotPasswordLinkTitle: function(d) { return " هل نسيت كلمة المرور؟"; },
    submit: function(d) { return select(d.hasAccount, { true: "تسجيل الدخول", other: "التسجيل" }); },
    languageRegistrationPrompt: function(d) { return "يُرجى إدخال الحقول التالية باللغة الإنجليزية"; }
  },
  loginForm: {
    login: function(d) { return "تسجيل الدخول"; },
    logonId: function(d) { return "البريد الإلكتروني"; },
    logonPassword: function(d) { return "كلمة المرور"; }
  },
  loginConsent: {
    title: function(d) { return "أجريت تغييرات على موقعنا"; },
    overlayBody1: function(d) { return "لقد حدثّنا سياسة الخصوصية وشروط وأحكام الحسابات لدينا منذ آخر زيارة لك لموقعنا. يرجى قراءة ما يلي والموافقة عليه قبل المتابعة."; },
    overlayBody2: function(d) { return " بالنقر على\"موافق\" ، ستؤكدون أنكم قرأتم وفهمتم شروط وأحكام الحساب وسياسة الخصوصية الخاصة بموقع THE OUTNET."; },
    pleaseNote1: function(d) { return "يرجى الملاحظة إذا"; },
    dontProceed: function(d) { return "لا تواصل"; },
    pleaseNote2: function(d) { return " لن نتمكن من استكمال تسجيلكم وسوف يتعين عليكم مواصلة استخدام الموقع كضيف. سوف تظل الشروط والأحكام وكذلك سياسة الخصوصية ساريتين في حال الدفع والخروج كضيف\r\n"; },
    termsAndConditions: function(d) { return "الشروط والأحكام"; },
    privacyPolicy: function(d) { return "سياسة الخصوصية "; },
    submit: function(d) { return "أوافق"; },
    and: function(d) { return ""; }
  },
  registrationForm: {
    register: function(d) { return "التسجيل"; },
    logonId: function(d) { return " البريد الإلكتروني"; },
    logonPassword: function(d) { return "إنشاء كلمة مرور جديدة"; },
    personTitle: function(d) { return "اللقب"; },
    firstName: function(d) { return "الاسم الأول"; },
    lastName: function(d) { return "اسم العائلة"; },
    phone1: function(d) { return ""; },
    dateOfBirth: function(d) { return ""; },
    day: function(d) { return "اليوم"; },
    month: function(d) { return "الشهر"; },
    year: function(d) { return "السنة"; },
    receiveEmailPreference: function(d) { return "اشترك بالرسائل الإخبارية"; },
    maMarketingConsent: function(d) { return "اشترك في نشرة المحتوى الحصري لموقع THE OUTNET والعلامات التجارية الأخرى من LuxExperience B.V. لتحصل على خصم %10 على طلبك التالي من THE OUTNET"; },
    discountDisclaimer: function(d) { return "[تُطبق الاستثناءات – تحقق من الشروط والأحكام هنا](https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes)"; },
    marketingYes: function(d) { return "نعم من فضلك!"; },
    marketingNo: function(d) { return "لا، شكرًا"; },
    selectTitle: function(d) { return " يُرجى اختيار اللقب"; },
    other: function(d) { return "أخرى..."; },
    privacyPolicy: function(d) { return " اكتشاف المزيد عن  "; },
    privacyPolicyTitle: function(d) { return "سياسة الخصوصية "; },
    termsAndConditions: function(d) { return " بمجرد إتمام عملية التسجيل، فأنتم توافقون على أنكم قرأتم وفهمتم"; },
    termsAndConditionsLink: function(d) { return "الأحكام والشروط الخاصة بموقع THE OUTNET"; },
    marketingError: function(d) { return "يُرجى تحديد خيار للاستمرار في عملية التسجيل"; },
    autoYesExplanation: function(d) { return " يُرجى اختيار \"لا،شكرًا\" في حال كنتم لا ترغبون في استقبال رسائل البريد الإلكتروني الترويجية منّا"; },
    genderMens: function(d) { return "الرجال"; },
    genderWomens: function(d) { return "السيدات"; },
    genderAll: function(d) { return "الجميع"; },
    emailReadMore: function(d) { return "ماذا سيصلني؟"; },
    emailInfo: function(d) { return "من خلال وضع علامة في مربع الاختيار، ستقوم بالتسجيل في موقع THE OUTNET وغيره من العلامات التجارية لشركة LuxExperience B.V.* وستصلك أخبار أحدث المنتجات بأسعار استثنائية، ونصائح للتصميمات التي أعدها الخبراء، وأحدث (وأفضل) عروضنا الترويجية.\n\nيمكنك إلغاء الاشتراك في أي وقت عن طريق إدارة تفضيلاتك في حسابك أو باتباع الإرشادات المذكورة في كل رسالة.\n\nتشمل *LuxExperience B.V. العلامات التجارية التالية:  MR PORTER ,Mytheresa ,NET-A-PORTER ,THE OUTNET ,YOOX.\n\nعند زيارتك أو استخدامك لمواقعنا الإلكترونية و/أو تطبيقاتنا، بما في ذلك الخدمات المقدمة عليها، سنقوم بمعالجة معلوماتك وفقًا لسياسة الخصوصية الخاصة بكل علامة تجارية: [MR PORTER](https://www.mrporter.com/content/help/privacy-policy/) ,[Mytheresa](https://www.mytheresa.com/to/service/privacy-policy) ,[NET-A-PORTER](https://www.net-a-porter.com/content/help/privacy-policy/) ,[THE OUTNET](https://www.theoutnet.com/page/policies/privacy-policy/) ,[YOOX](https://www.yoox.com/Legal/Privacypolicy)."; },
    emailInfo1: function(d) { return "يمكنكم الاشتراك أو إلغاء الاشتراك بخدمة رسائل البريد الإلكتروني في أي وقت عبر تغيير الخيارات في حسابكم"; },
    emailTitle: function(d) { return "رسائل البريد الإلكتروني الخاصة بنا"; },
    genderSelectionLabel: function(d) { return "يرجى الاختيار من بين التفضيلات"; },
    gdprConsentTerms: function(d) { return "I agree to the [Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; },
    gdprConsentPrivacy: function(d) { return "Personal data provided by you will be processed for account registration purposes in accordance with our [Privacy Policy](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/)."; },
    gdprConsentError: function(d) { return "Required field"; },
    checkAll: function(d) { return "Check all"; },
    ageConsent: function(d) { return "I confirm that I am 14 years old or older (mandatory)"; },
    tcConsent: function(d) { return "Consent to [the collection and use of personal information]() (mandatory)"; },
    newsletterConsent: function(d) { return "أوافق على جمع واستخدام معلوماتي الشخصية] لأغراض تسويقية، وذلك لتلقي التحديثات عبر البريد الإلكتروني حول الأخبار، وأحدث الإصدارات، والمبادرات الترويجية من ]() THEOUTNET وغيرها من علامات LuxExperience B.V.، كجزء من أنشطتنا التسويقية الموجّهة (اختياري) "; },
    termsAndConditionsAcceptance: function(d) { return "بمجرد إتمام عملية التسجيل، فأنتم توافقون على أنكم قرأتم وفهمتم[الأحكام والشروط الخاصة بموقع THE OUTNET](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/) و[ سياسة الخصوصية](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/)\n\nمن خلال الضغط على \"تسجيل حساب جديد\" أنت توافق على الانضمام إلى برنامج المكافآت الخاص بنا المنظم بموجب [الشروط والأحكام](https://www.theoutnet.com/" + d.locale + "/page/policies/general-terms-and-conditions-of-sale/#outnet-rewards) وستستمتع بالميزات الإضافية المدرجة في [شروط وأحكام حسابي](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; }
  },
  marketingPreferences: {
    pageError: function(d) { return "عذراً، لقد حدث خطأ ما"; },
    retryNow: function(d) { return "يُرجى إعادة المحاولة"; },
    emptyLabel: function(d) { return "يُرجى اختيار..."; },
    countryLangSectionTitle: function(d) { return "تفضيلات الدولة واللغة"; },
    countryLangSectionText: function(d) { return "يرجى تحديد الدولة التي تتسوقينَ منها واللغة التي ترغبينَ في تلقي مراسلاتنا بها."; }
  },
  emailPasswordTokenForm: {
    title: function(d) { return "نسيت كلمة المرور "; },
    info: function(d) { return "سنرسل لك رابطًا عبر البريد الإلكتروني لإنشاء كلمة مرور جديدة."; },
    logonId: function(d) { return " البريد الإلكتروني"; },
    cancel: function(d) { return "إلغاء"; },
    send: function(d) { return "إرسال"; },
    sentEmailSuccess: function(d) { return "رائع! تم إرسال رسالة إلى " + d.email + " تحتوي على رابط لإنشاء كلمة مرور جديدة "; },
    backToLogin: function(d) { return "العودة إلى صفحة تسجيل الدخول"; },
    confirmation: function(d) { return "تمّ بنجاح!"; }
  },
  forgotPassword: {
    cancel: function(d) { return "إلغاء"; }
  },
  resetPasswordForm: {
    title: function(d) { return "كلمة المرور الجديدة"; },
    logonId: function(d) { return " البريد الإلكتروني"; },
    createPassword: function(d) { return "إنشاء كلمة مرور جديدة"; },
    confirmPassword: function(d) { return "تأكيد كلمة المرور الجديدة"; },
    submit: function(d) { return "تسجيل الدخول"; },
    resetSuccess: function(d) { return "تمّ تحديث كلمة المرور الخاصة بك بنجاح. يمكنك تسجيل الدخول باستخدام كلمة المرور الجديدة الآن."; },
    "continue": function(d) { return "العودة إلى صفحة تسجيل الدخول"; },
    confirmation: function(d) { return "شكرًا!"; }
  },
  orderHistory: {
    title: function(d) { return "طلبيّاتي"; },
    description: function(d) { return "عرض طلبياتك لإلقاء نظرة على مشترياتك أو تتبع عملية توصيلها"; },
    terms: function(d) { return " إن لم تكن مشترياتكم تلبّي توقعاتكم، فأمامكم " + d.returnWindow + " يوماً منذ استلام الطلب لتتمكنوا من إرجاع القطع التي اشتريتوها أو استبدالها أو استرداد أموالكم."; },
    noOrdersTitle: function(d) { return "ليس لديك أيّ طلبيات"; },
    noOrdersDescription: function(d) { return "بمجرد دفع المبلغ، يمكنك استعراض طلبيتك وتتبعها هنا"; },
    paginationDetails: function(d) { return "عرض " + d.totalOrdersDisplayed + "  من " + d.totalOrders + " الطلبات"; },
    loadMore: function(d) { return "رؤية المزيد"; },
    noOrdersLinkTitle: function(d) { return " تسوّقوا كل ما هو جديد"; },
    errorLoadingMoreOrders: function(d) { return "نعتذر، لم نتمكّن من تحميل طلبيات أخرى، يُرجى المحاولة لاحقًا "; },
    errorLoadingMorePastOrders: function(d) { return "نعتذر، لم نتمكّن من تحميل المزيد من الطلبيات السابقة  "; },
    pageError: function(d) { return "عذرًا، حدث خطئ ما "; },
    retryButton: function(d) { return " يُرجى إعادة المحاولة الآن"; },
    recentOrders: function(d) { return select(d.error, { false: "الطلبيات الحالية(" + d.totalOrders + ")", true: "الطلبيات الحالية", other: "" }); },
    pastOrders: function(d) { return select(d.error, { false: "الطلبيات السابقة(" + d.totalOrders + ")", true: "الطلبيات السابقة", other: "" }); },
    canBeExchanged: function(d) { return ""; },
    canBeRefunded: function(d) { return ""; },
    cannotBeExchanged: function(d) { return ""; },
    cannotBeRefunded: function(d) { return ""; },
    customerCare: function(d) { return "خدمة العملاء"; }
  },
  orderItem: {
    orderId: function(d) { return "الطلب " + d.displayId; },
    date: function(d) { return "التاريخ: " + d.placedDate; },
    price: function(d) { return "مجموع: " + d.price; },
    viewDetails: function(d) { return "عرض التفاصيل "; },
    trackOrder: function(d) { return "تتبّع طلبيّتي"; },
    trackExchange: function(d) { return "تتبّع عملية النبديل"; }
  },
  orderStatus: {
    pending: function(d) { return "يعالج"; },
    cancelled: function(d) { return "تم الإلغاء"; },
    dispatched: function(d) { return "تم الإرسال"; },
    exchangeReceived: function(d) { return "تم استلام القطعة المُراد استبدالها"; },
    exchanged: function(d) { return "مستبدل"; },
    ordered: function(d) { return "لقد تمّت الطلبية"; },
    processing: function(d) { return "تحضير طلبيتكم جارٍ على قدم وساق"; },
    returnCompleted: function(d) { return "تم الاسترجاع"; },
    returnReceived: function(d) { return "تم استلام المسترجعات"; },
    returnRequest: function(d) { return "طلب الاسترجاع"; },
    returned: function(d) { return "تم الاسترجاع"; },
    viewDetails: function(d) { return "عرض التفاصيل"; },
    returnRequested: function(d) { return "تم إرسال طلب الاسترجاع"; },
    returnRefused: function(d) { return "عملية استبدال مرفوضة"; },
    exchangeOrdered: function(d) { return "تم الطلب"; },
    exchangeProcessing: function(d) { return "يتم العمل على تجهيزها"; },
    inTransit: function(d) { return "مع المندوب"; },
    delivered: function(d) { return "تم التوصيل"; },
    returnProcessing: function(d) { return "المرتجعات قيد المراجعة"; },
    returnInTransit: function(d) { return "المرتجعات في مرحلة النقل"; },
    returnRefunded: function(d) { return "تم تعويض المرتجعات"; },
    partiallyReturnRefunded: function(d) { return " تم تعويض المرتجعات بشكل جزئي"; },
    partiallyReturnRefused: function(d) { return "لم يقبل جزء من مرتجعاتك"; },
    returnAccepted: function(d) { return "قبول الطلبية المعادة"; }
  },
  orderItemStatus: {
    RETURN_REQUESTED: function(d) { return "تم إرسال طلب الاسترجاع"; },
    RETURN_ACCEPTED: function(d) { return "قبول الطلبية المعادة"; },
    RETURN_REFUNDED: function(d) { return "تم تعويض المرتجعات"; },
    RETURN_REFUSED: function(d) { return "عملية استبدال مرفوضة"; },
    CANCELLED: function(d) { return "تم الإلغاء"; },
    EXCHANGE_ACCEPTED: function(d) { return "تم استلام القطعة المُراد استبدالها"; },
    EXCHANGED: function(d) { return "مستبدل"; }
  },
  orderEvents: {
    TRANSFERRED: function(d) { return "نحن في انتظار استلام القطع التي طلبتموها من مكتبنا في أوروبا"; },
    SCHEDULED: function(d) { return "نحن جاهزون لتوضيب طلبيتكم"; },
    RELEASED: function(d) { return "طلبيتكم جاهزة، وستكون في الطريق إليكم قريبًا"; },
    TRANSIT_001: function(d) { return "خرجت الطلبية للتوصيل"; },
    TRANSIT_002: function(d) { return "طلبيتكم محفوظة في أمان لحين توصيلها إليكم"; },
    TRANSIT_003: function(d) { return "لقد وصلت طلبيتكم إلى الموقع المحدد"; },
    EXCEPTION_001: function(d) { return "تمت محاولة للتوصيل"; },
    EXCEPTION_002: function(d) { return "التأخير حصل بسبب الجمارك"; },
    EXCEPTION_003: function(d) { return "تمت محاولة للتوصيل"; },
    EXCEPTION_004: function(d) { return "عنوان غير صحيح يُرجى التواصل مع خدمة العملاء"; },
    EXCEPTION_005: function(d) { return "عنوان غير صحيح يُرجى التواصل مع خدمة العملاء"; },
    EXCEPTION_006: function(d) { return "لقد عادت طلبيتك إلينا"; },
    EXCEPTION_007: function(d) { return "المتلقي غير متوفر في العنوان المذكور"; },
    EXCEPTION_008: function(d) { return "المحل مغلق في وقت التوصيل "; },
    EXCEPTION_009: function(d) { return "لم يتم تسليم الطرد بسبب بعض الاستثناءات في الشحن"; },
    EXCEPTION_010: function(d) { return "لم يتم تسليم الطرد بسبب تغيير موقع المتلقي"; },
    EXCEPTION_011: function(d) { return "لم يتم تسليم الطرد بسبب رفض المتلقي استلامه نظرًا لسبب معين "; },
    EXCEPTION_012: function(d) { return "تم حجز الطرد بسبب عدم تسديد المبلغ من قبل العميل"; },
    EXCEPTION_013: function(d) { return "الطرد جاهز للاستلام ولكن لم يتم أخذها من قبل العميل "; },
    EXCEPTION_014: function(d) { return "تم رفض الطرد من قبل شركة النقل بسبب عدم امتثاله للتعليمات."; },
    EXCEPTION_015: function(d) { return "تلف في الشحنة "; },
    EXCEPTION_016: function(d) { return "لم يتم تسليم الطرد بسبب الضياع"; }
  },
  returnEvents: {
    TRANSIT_001: function(d) { return "الشحنة في الطريق"; },
    TRANSIT_002: function(d) { return "مرتجعاتك في المركز المحلي أو منشأة الفرز"; },
    TRANSIT_003: function(d) { return d.country + " وصلت مرتجعاتك إلى "; },
    EXCEPTION_001: function(d) { return "لم تصل مرتجعاتك بنجاح، سنعيد المحاولة قريبًا"; },
    EXCEPTION_002: function(d) { return "تأخرت مرتجعاتك لدى الجمارك"; },
    EXCEPTION_003: function(d) { return "تأخر وصول مرتجعاتك"; },
    EXCEPTION_004: function(d) { return "Incorrect address. Contact Customer Care"; },
    EXCEPTION_005: function(d) { return "Your order is coming back to us"; },
    EXCEPTION_006: function(d) { return "Your order has arrived back with us"; },
    EXCEPTION_007: function(d) { return "المتلقي غير متوفر في العنوان المذكور"; },
    EXCEPTION_008: function(d) { return "المحل مغلق في وقت التوصيل "; },
    EXCEPTION_009: function(d) { return "لم يتم تسليم الطرد بسبب بعض الاستثناءات في الشحن"; },
    EXCEPTION_010: function(d) { return "لم يتم تسليم الطرد بسبب تغيير موقع المتلقي"; },
    EXCEPTION_011: function(d) { return "لم يتم تسليم الطرد بسبب رفض المتلقي استلامه نظرًا لسبب معين "; },
    EXCEPTION_012: function(d) { return "تم حجز الطرد بسبب عدم تسديد المبلغ من قبل العميل"; },
    EXCEPTION_013: function(d) { return "الطرد جاهز للاستلام ولكن لم يتم أخذها من قبل العميل "; },
    EXCEPTION_014: function(d) { return "تم رفض الطرد من قبل شركة النقل بسبب عدم امتثاله للتعليمات."; },
    EXCEPTION_015: function(d) { return "تلف في الشحنة "; },
    EXCEPTION_016: function(d) { return "لم يتم تسليم الطرد بسبب الضياع"; },
    RETURN_RECEIVED: function(d) { return "تم استلام مرتجعاتك"; },
    RETURN_ACCEPTED: function(d) { return "تم قبول مرتجعاتك"; },
    PARTIALLY_RETURN_ACCEPTED: function(d) { return "تم قبول جزء من مرتجعاتك"; }
  },
  orderStatusDesc: {
    ordered: function(d) { return "سنبدأ تجهيز طلبيتكم قريبًا"; },
    processing: function(d) { return "نعمل على إعداد طلبيتكم"; },
    dispatched: function(d) { return "لقد خرجت الطلبية من مركزنا للتوصيل"; },
    inTransit: function(d) { return "طلبيتكم في طريقها إليكم"; },
    delivered: function(d) { return ""; },
    cancelled: function(d) { return " تم إلغاء طلبكم  إن لم ترغبوا بإلغاء الطلبية وتحتاجون للمزيد من المعلومات، يرجى التواصل مع قسم خدمة العملاء عبر " + d.phone + " أو " + d.mail + " "; },
    returnRefused: function(d) { return " نعتذر، مُرتجعاتكم غير مقبولة. للمزيد من المعلومات، يرجى الاتصال بخدمة العملاء على الرقم " + d.phone + " أو عبر البريد الإلكتروني " + d.mail; },
    phone: function(d) { return "الهاتف"; },
    email: function(d) { return "البريد الإلكتروني"; }
  },
  orderDetails: {
    title: function(d) { return "تفاصيل الطلبيّة"; },
    orderInfo: function(d) { return " نشكركم على طلبيّتكم " + d.userTitle + " " + d.userLastName + ". رقم طلبيتكم هو "; },
    orderItemsTitle: function(d) { return "ماذا طلبت"; },
    returnsConditions: function(d) { return "يمكنكم تبديل طلبيتكم أو إرجاعها إلينا خلال " + d.returnWindow + " يومًا من توصيلها إليكم."; },
    quantity: function(d) { return "الكمية: " + d["الكميّة"] + " "; },
    totalsTitle: function(d) { return "ملخص الطلبية"; },
    trackOrder: function(d) { return "تتبّع طلبيّتي"; },
    trackReturn: function(d) { return "تتبع عودتي"; },
    trackExchange: function(d) { return "تتبّع عملية النبديل"; },
    dateShipped: function(d) { return "إن الطلبية " + d.displayId + " في طريقها إليك وقد تمّ شحنها في تاريخ " + d.dateShipped + "."; },
    timeDelivered: function(d) { return "لقد تم شحن توصيل طلبيتك " + d.timeDelivered + ". لديك " + d.returnWindow + " يومًا من تاريخ التوصيل لإرجاع القطَع."; },
    timeExchangeDelivered: function(d) { return "لقد تم شحن توصيل طلبيتك " + d.timeDelivered + ". لديك " + d.returnWindow + " يومًا من تاريخ التوصيل لإرجاع أو ستبدال القطَع."; },
    pageError: function(d) { return "عذرًا، حدث خطئ ما"; },
    retryButton: function(d) { return " يُرجى إعادة المحاولة الآن"; },
    createExchange: function(d) { return "إنشاء طلب تبديل/إرجاع"; },
    createReturn: function(d) { return "إرجاع المشتريات"; },
    review: function(d) { return "استمرار"; },
    cancel: function(d) { return "إلغاء"; },
    cancelReturn: function(d) { return "إلغاء الإرجاع"; },
    reviewChanges: function(d) { return "مراجعة التغييرات"; },
    edit: function(d) { return "تعديل"; },
    returnStatus: function(d) { return select(d.type, { "return": "تم إرسال طلب الإرجاع", exchange: "تم إرسال طلب التبديل", other: "" }); },
    returnTitle: function(d) { return "القطع المرتجعة"; },
    exchangeTitle: function(d) { return "تبديل أو إرجاع "; },
    exchangeReturn: function(d) { return "إنشاء طلب تبديل/إرجاع"; },
    "return": function(d) { return "الإرجاع"; },
    confirmReturnTitle: function(d) { return "تأكيد على الإرجاع"; },
    confirmMessage: function(d) { return " يُرجى التأكيد والموافقة على القطع التي ترغبون بإرجاعها."; },
    returnConfirmation: function(d) { return "نشكرك على تقديم طلبك " + d["الاسم"]; },
    returnConfirmationMessage: function(d) { return " أرسلنا بريدًا إلكترونيًا إلى " + d.email + "  بجميع المعلومات التي تحتاجونها لمتابعة العملية."; },
    createStep: function(d) { return "إنشاء"; },
    confirmStep: function(d) { return "تأكيد"; },
    collectionStep: function(d) { return "الإرجاع"; },
    completeStep: function(d) { return "اكتمال"; },
    exit: function(d) { return " هل أنت متأكّدون أنّكم تريدون مغادرة هذه الصفحة وإلغاء طلبكم؟"; },
    productCode: function(d) { return "رمز المنتج"; },
    viewMoreDetails: function(d) { return "عرض تفاصيل أكثر"; },
    customerCare: function(d) { return "لم تَعد القطع متاحة للإرجاع أو الاستبدال. يُرجى التواصل مع " + d.customerService + " للحصول على مساعدة."; },
    customerService: function(d) { return "خدمة العملاء"; },
    yourExchangesInfo: function(d) { return "رقم طلبيتك المستبدلة هو:"; },
    createdExchangesTitle: function(d) { return "لقد قمت بإنشاء طلب استبدال"; },
    createdExchangesInfo: function(d) { return "لقد قمت بتعبئة نموذج استبدال أو أكثر لعناصر هذه الطلبية. "; },
    createdReturnsTitle: function(d) { return "لقد قمت بإنشاء طلب إرجاع المشتريات"; },
    createdReturnsInfo: function(d) { return "لقد قمت بتعبئة نموذج إرجاع أو أكثر لعناصر هذه الطلبية. "; },
    finalSale: function(d) { return "الخصومات النهائية - هذه القطعة غير قابلة للإرجاع"; },
    orderStatus: function(d) { return "حالة الطلب"; },
    splitShipmentMessage: function(d) { return "نظراً لأن مشترياتك تحتوي على منتج قادم من أحد مواقعنا الأخرى، فسيتم إرساله وتوصيله بشكلٍ منفصل."; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "اعتيادي", EXPRESS: "سريع", SATURDAY_DELIVERY: "توصيل يوم السبت", NEXT_DAY_DELIVERY: "توصيل اليوم الثاني", KIALA_STANDARD: "كيالا", DELIVER_TO_STORE: "التوصيل إلى المتجر", PREMIER_DAYTIME: "Premier Daytime", other: "" }); },
    delayMessage: function(d) { return select(d.country, { GB: "يرجى التأكد من ملئ نماذج الإرجاع الثلاثة المرفقة مع الطرد عند إرجاع الطلب لضمان التخليص الجمركي السلس وتجنب تأخير استرداد المبلغ. .لمزيد من المعلومات، تعرّفي على  [سياسة الإرجاع](https://www.theoutnet.com/en-gb/page/help/returns/) الخاصة بنا", other: "" }); },
    freeReturnFeeInfo: function(d) { return ""; }
  },
  createCollection: {
    bookCollection: function(d) { return "رتب موعدًا لتسليم الطلبية"; },
    returnLabelBtn: function(d) { return select(d.hasRequested, { true: "طلب ملصق الإرجاع", other: "طلب ملصق الإرجاع" }); },
    returnLabelInfo: function(d) { return "لقد أرسلنا أوراق الإرجاع الخاصة بكِ داخل شحنتكِ. إذا أضعتِ فاتورتكِ المبدئية للإرجاع، يرجى التواصل معنا ‪[هنا](/" + d.locale + "/page/help/contact/)‬. لطلب ملصق إرجاع جديد، يرجى الضغط أدناه."; },
    returnLabelSuccess: function(d) { return "لقد أرسلنا أوراق الإرجاع الخاصة بكِ داخل شحنتكِ. إذا أضعتِ فاتورتكِ المبدئية للإرجاع، يمكنكِ إيجادها مُرفقةً بالبريد الإلكتروني الخاص بتأكيد الشحن. لطلب ملصق إرجاع جديد، يرجى الضغط أدناه."; },
    returnLabelError: function(d) { return select(d.error, { ERR_UNABLE_TO_REPRINT_LABEL: "نظراً لأن إصدار مستندات الإرجاع قد يستغرق حتى 24 ساعة، يمكنكِ تقديم طلب واحد فقط يومياً.", ERR_BAD_RESPONSE_FROM_EXTERNAL_SYSTEM: "عذراً، نظامنا غير متاح مؤقتاً. يرجى التحقق مرة أخرى بعد بضع ساعات وإعادة المحاولة مرة أخرى.", ERR_EXTERNAL_SALESFORCE_SERVICE_UNAVAILABLE: "عذراً، نظامنا غير متاح مؤقتاً. يرجى التحقق مرة أخرى بعد بضع ساعات وإعادة المحاولة مرة أخرى.", other: "عذراً، نظامنا غير متاح مؤقتاً. يرجى التواصل مع فريق خدمة العملاء للمزيد من المساعدة." }); },
    title: function(d) { return "إرجاع الطلبية"; },
    subTitle: function(d) { return " ما هي طريقة الإرجاع التي تفضّلونها؟"; },
    optionCollection: function(d) { return " يُرجى ترتيب موعد لتسليم الطلبية"; },
    optionDropOff: function(d) { return " يُرجى تسليم الطلبية في نقطة خدمة " + d.returnCourier; },
    submit: function(d) { return "استمرار"; },
    courierTimingMessage: function(d) { return "أقرب موعد للاستلام:"; },
    courierTimingSelectedMessage: function(d) { return "فيما يلي تاريخ التشكيلة التي وقع عليها اختياركِ:"; },
    selectDateLabel: function(d) { return "يُرجى تحديد اليوم"; },
    addressMessage: function(d) { return "ستُستلم من:"; },
    specialInformationMessage: function(d) { return "تعليمات إضافية لشركة التوصيل " + d.returnCourier; },
    boxQuantityMessage: function(d) { return " كم عدد الصناديق التي تودّون إرجاعها؟"; },
    skipReturn: function(d) { return "سأرتّب الإرجاع لاحقًا"; },
    dropOffRequested: function(d) { return "لقد طلبت تسليم طردك"; },
    courierServicePoint: function(d) { return " يُرجى البحث عن أقرب نقطة خدمة " + d.returnCourier + " إليكم"; },
    returnConfirmationNumber: function(d) { return "رقم تأكيد الإرجاع: "; },
    collectionTime: function(d) { return " لقد طلبتم الاستلام"; },
    parcelQuantity: function(d) { return "عدد الصناديق: "; },
    contactCustomerCare: function(d) { return " إذا كنتم ترغبون في استخدام عنوان مختلف، أو حجز موعد مختلف، فأكملوا هذه الخطوة مع فريق خدمة العملاء لدينا على الرقم " + d.phone + " أو عنوان البريد الإلكتروني " + d.mail; },
    error: function(d) { return select(d.createError, { timeSlotError: "انتهَت صلاحية الفترة الزمنية التي اخترتِها بالفعل. الرجاء اختيار فترة زمنية أخرى.", other: " نواجه صعوبات في التواصل مع " + d.returnCourier + ". عوضًا عن ذلك، يمكنكم الاتصال بفريق خدمة العملاء لدينا لحجز موعد الاستلام أو الحجز مباشرة على موقع شركة الشحن" }); },
    maxLength: function(d) { return "يجب أن يتكون من " + d.characters + " حروف أو أقل"; },
    chooseAnotherDay: function(d) { return " ألم يَرق لكم هذا اليوم؟ يُرجى اختيار يوم آخر"; },
    chosenDayNotAvailable: function(d) { return "عذرًا، ذلك التاريخ غير متاح. يُرجى اختيار تاريخ آخر."; },
    timeSlot: {
      now: function(d) { return "الآن"; },
      betweenTimeSlot: function(d) { return " بين الساعة " + d.pickupTime + " - " + d.pickupLatest; },
      today: function(d) { return "اليوم"; },
      tomorrow: function(d) { return "غدًا"; },
      monday: function(d) { return "الاثنين"; },
      tuesday: function(d) { return "الثلاثاء"; },
      wednesday: function(d) { return "الأربعاء"; },
      thursday: function(d) { return "الخميس"; },
      friday: function(d) { return "الجمعة"; },
      saturday: function(d) { return "السبت"; },
      sunday: function(d) { return "الأحد"; }
    }
  },
  orderTracking: {
    trackDetails: function(d) { return "تتبعوا طلبيتكم"; },
    subTitle: function(d) { return "تتبعوا مشترياتكم من لحظة خروجها من مركزنا إلى أن تصل إلى عتبة بابكم."; },
    estimatedDeliveryDateInfo: function(d) { return "سنعلمكم بتاريخ التوصيل المتوقع بمجرد خروج طلبيتكم من مركزنا."; },
    estimatedDeliveryDateInfoPremier: function(d) { return "Once your purchase has left us, we'll be in touch via phone or email with a delivery window"; },
    estimatedDeliveryDate: function(d) { return "تاريخ التوصيل المتوقع"; },
    deliveredOn: function(d) { return "تم التوصيل في "; },
    order: function(d) { return d.orderId + " رقم الطلب"; },
    trackingLink: function(d) { return "عرض تتبع المندوب"; },
    courierTrackingNumber: function(d) { return " يُرجى إدخال رقم التتبع الخاص بكم " + d.trackingNumber + " لتتبّع طلبكم على موقع التوصيل السريع. "; },
    trackingDetails: function(d) { return "تتبع التفاصيل"; },
    delivered: function(d) { return "تم التوصيل في:  " + d.timeDelivered; },
    dispatched: function(d) { return "تم الشحن " + d.timeShipped; },
    processing: function(d) { return "يعالج"; }
  },
  returnTracking: {
    trackDetails: function(d) { return "تتبع طلبيتك المُعادة"; },
    subTitle: function(d) { return " تتبعوا مُرتجعاتكم من بابكم إلى بابنا "; },
    estimatedRefundDateInfo: function(d) { return "نهدف إلى مراجعة مُرتجعاتك خلال ثلاثة أيام عمل من يوم استلام طلبك وسنتواصل معك مجددًا عند إصدار مبلغ التعويض"; },
    trackingLink: function(d) { return "عرض تتبع المندوب"; },
    returnedToWarehouseOn: function(d) { return "أُعيدت إلى المخزن في: "; },
    partialReturn: function(d) { return "جزءٌ من مُرتجعاتك غير مقبول. للمزيد من المعلومات، يرجى مرأدخل رقم التتبع الخاص بك 5505732433 للعودة إلى موقع ااجعة تفاصيل طلبك أو الاتصال بخدمة العملاء على الرقم " + d.phone + " أو عبر البريد الإلكتروني " + d.mail; },
    courierTrackingNumber: function(d) { return " يُرجى إدخال رقم التتبع الخاص بكم " + d.trackingNumber + " للعودة إلى موقع التوصيل السريع. "; }
  },
  guestOrderTracking: {
    trackOrder: {
      title: function(d) { return " تتبعوا طلبيتكم"; },
      info: function(d) { return "يُرجى إدخال رقم طلبيتكم بالفراغ المبين أدناه لمراجعة عملية الشراء وعرض حالة تسليمه."; },
      helpInfo: function(d) { return "إذا كنت قد أقدمت على إنشاء طلبيتك  للتو، فسوف يستغرق التحديث بضع دقائق."; },
      error: function(d) { return "عذرًا، لا يوجد طلبية مسترجعة تطابق مع الرقم الذي أدخلته. يُرجى التحقق والمحاولة مرة أخرى"; },
      lables: {
        email: function(d) { return "عنوان البريد الإلكتروني:"; },
        orderId: function(d) { return "رقم الطلبية"; },
        button: function(d) { return "البحث"; }
      }
    },
    trackReturn: {
      title: function(d) { return "تتبع طلبيتك المُرجعة"; },
      info: function(d) { return "يُرجى إدخال رقم طلبيتك بالفراغ المبين أدناه لمراجعة حالة الإرجاع."; },
      helpInfo: function(d) { return "إذا كنت قد أقدمت على إنشاء عملية إرجاع للتو، فسوف يستغرق التحديث بضع دقائق."; },
      error: function(d) { return "عذرًا، لا يوجد طلبية مسترجعة تطابق مع الرقم الذي أدخلته. يُرجى التحقق والمحاولة مرة أخرى"; },
      lables: {
        email: function(d) { return "عنوان البريد الإلكتروني:"; },
        orderId: function(d) { return "رقم الطلبية"; },
        button: function(d) { return "البحث"; }
      }
    },
    createReturn: {
      title: function(d) { return "يُرجى إنشاء نموذج إرجاع"; },
      info: function(d) { return "يُمكنك إنشاء عملية إرجاع لمشترياتك خلال " + d.returnWindow + " يومًا من استلام الفاتورة. بالإضافة إلى أننا سنقوم بالمجيئ لاستلام المرجعات من منزلك أو مكان عملك أو أيّ عنوان بديل."; },
      proformaInfo: function(d) { return "يرجى التأكد من ملئ نموذج الإرجاع المرفق مع الطرد عند إرجاع الطلب لضمان التخليص الجمركي السلس. "; },
      helpInfo: function(d) { return "يجب إرجاع العناصر جديدة وغير مستخدمة ومع جميع شارات THE OUTNET وشارة مصمم الملابس مرفقة بها. لمزيد من المعلومات، يُرجى الرجوع إلى [سياسة المرجعات](/" + d.locale + "/page/help/returns/) الخاصة بنا"; },
      error: function(d) { return "عذرًا، لا يوجد طلبية مسترجعة تطابق مع الرقم الذي أدخلته. يُرجى التحقق والمحاولة مرة أخرى"; },
      lables: {
        email: function(d) { return "عنوان البريد الإلكتروني:"; },
        orderId: function(d) { return "رقم الطلبية"; },
        button: function(d) { return "البحث"; }
      },
      notReturnable: function(d) { return "نعتذر، هذه الطلبية لا يُمكن إرجاعها. يُرجى مراجعة سياسة الإرجاع لدينا للحصول على المزيد من المعلومات "; }
    }
  },
  marketing: {
    subscribeCta: function(d) { return "اشترك الآن"; },
    updatePreferencesCta: function(d) { return "تحديث تفضيلات"; },
    manageSubscriptionsCta: function(d) { return "إدارة الاشتراكات"; },
    moreDetails: function(d) { return "لمزيد من المعلومات حول كيفية معالجة بياناتكِ، يرجى الاطلاع على [سياسة الخصوصية الخاصة بن](/" + d.locale + "/page/policies/privacy-policy/)"; },
    updateError: function(d) { return "لا يمكن تحديث تفضيلات البريد الإلكتروني. يُرجى إعادة المحاولة لاحقاً."; }
  },
  unsubscribe: {
    viewAll: function(d) { return "استعرضي جميع علاماتنا التجارية"; },
    allBrands: function(d) { return "كل العلامات"; },
    unsubscribeBtn: function(d) { return "إلغاء الاشتراك"; }
  },
  price: {
    original: function(d) { return "السعر"; },
    discountPercentage: function(d) { return "(-%" + d.discountPercentage + ")"; },
    wasPriceOriginal: function(d) { return "سعر التجزئة الموصى به: " + d.wasPrice; },
    wasPrice: function(d) { return "سعر التجزئة الموصى به:"; },
    originalPrice: function(d) { return "السعر الأصلي:"; },
    discountApplied: function(d) { return "يُطبق العرض: "; },
    itemTax: function(d) { return select(d.included, { true: "شامل", other: "" }) + "الضريبة: "; },
    tax: function(d) { return "الضريبة: "; },
    duties: function(d) { return select(d.included, { true: "شامل", other: "" }) + "Duties: "; },
    final: function(d) { return "مجموع العناصر"; },
    promoApplied: function(d) { return "يتم تطبيق " + select(d.description, { undefined: "Promotion", other: d.description }); },
    salesTax: function(d) { return "الضريبة: "; }
  },
  purchasePath: {
    edit: function(d) { return "تعديل"; }
  },
  orderPaymentSummary: {
    shippedTo: function(d) { return "تم الشحن إلى"; },
    shippingMethod: function(d) { return "طريقة الشحن"; },
    billedTo: function(d) { return "تصدر الفواتير إلى"; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "اعتيادي", EXPRESS: "سريع", SATURDAY_DELIVERY: "توصيل يوم السبت", NEXT_DAY_DELIVERY: select(d.country, { GB: "سريع", other: "توصيل اليوم الثاني" }), KIALA_STANDARD: "كيالا", DELIVER_TO_STORE: "التوصيل إلى المتجر", PREMIER_DAYTIME: "Premier Daytime", other: "" }); },
    paymentType: function(d) { return select(d.type, { CREDIT_CARD: "بطاقة الائتمان", PAYPAL: "باي بال ", PAYPAL_EXPRESS: "باي بال إكسبرس", ALIPAY: "أليباي", PAYEASE: "باي إيز", PAYEASE_INTERNATIONAL: "باي إيز إنترناشونال", COD: "الدفع عند الاستلام", WIRE_TRANSFER: "حوالة مصرفية", SOFORT: "Sofort", STORE_CREDIT: "رصيد المتجر", KLARNA_PAY_NOW: "Pay Now", KLARNA_PAY_LATER: "Pay in 30 days", KLARNA_SLICE_IT: "Pay in instalments", other: "" }); }
  },
  lineItem: {
    quantity: function(d) { return "الكمية: "; }
  },
  cardWallet: {
    title: function(d) { return "البطاقات المحفوظة"; },
    description: function(d) { return "عرض وإدارة طرق الدفع"; },
    emptyListTitle: function(d) { return "ليس لديكِ أي بطاقات محفوظة"; },
    emptyListDetails: function(d) { return "أضِف بطاقة لإتمام عملية الشراء بشكلٍ أسرع"; },
    addCard: function(d) { return "إضافة بطاقة"; },
    edit: function(d) { return "تعديل"; },
    "delete": function(d) { return "حذف"; },
    cancel: function(d) { return "إلغاء"; },
    success: function(d) { return select(d.method, { ADD: "لقد قمتِ بحذف البطاقة التي تنتهي بالرقم " + d.cardLastFour, EDIT: "لقد قمتِ بتحديث البطاقة التي تنتهي بالرقم " + d.cardLastFour, DELETE: "لقد قمتَ بحذف البطاقة التي تنتهي بالرقم " + d.cardLastFour, other: "" }); },
    deleteTitle: function(d) { return "حذف البطاقة الائتمانية"; },
    deletePrompt: function(d) { return " هل أنتم متأكدون من رغبتكم بحذف البطاقة التي تنتهي بالرقم " + d.cardNumber + "؟"; },
    deleteError: function(d) { return "حدث خلل أثناء حذف البطاقة التي تنتهي بالرقم " + d.cardNumber; },
    pageError: function(d) { return "عذرًا، حدث خطئ ما"; },
    retryButton: function(d) { return " يُرجى إعادة المحاولة الآن"; }
  },
  creditCardForm: {
    title: function(d) { return select(d.method, { ADD: "إضافة بطاقة", EDIT: "تعديل بيانات البطاقة", other: "" }); },
    number: function(d) { return "رقم البطاقة"; },
    cardHolderName: function(d) { return "الاسم على البطاقة"; },
    expiryDate: function(d) { return "تاريخ الانتهاء*"; },
    month: function(d) { return "الشهر"; },
    monthPlaceholder: function(d) { return "الشهر"; },
    year: function(d) { return "السنة"; },
    cardDetails: function(d) { return "بيانات البطاقة"; },
    yearPlaceholder: function(d) { return "السنة"; },
    cvv: function(d) { return d.cvvType; },
    cvvHelp: function(d) { return plural(d.cvvSize, 0, en, { "0": "رمز الأمان ", other: number(d.cvvSize, "cvvSize") + " الأرقام " }) + "على " + select(d.cvvType, { CID: "الجهة الأمامية", other: "الجهة الخلفية " }) + "من البطاقة"; },
    submit: function(d) { return "حفظ"; },
    privacyPolicy: function(d) { return "سيتم استخدام معلومات البطاقة التي تقدّميها من قِبَل THE OUTNET لتسريع عملية الشراء. يرجى مراجعة [سياسة الخصوصية](/" + d.locale + "/page/policies/privacy-policy/) الخاصة بنا لمزيد من المعلومات حول حقوقكِ."; },
    acceptedCards: function(d) { return "البطاقات المقبولة"; },
    error: function(d) { return "عذرًا، حدث خطئ ما"; }
  },
  card: {
    expiry: function(d) { return "انتهاء الصلاحية "; },
    expired: function(d) { return "منتهية الصلاحية"; },
    cardHolder: function(d) { return " اسم حامل البطاقة"; }
  },
  customerCare: {
    service: function(d) { return ""; },
    customerCare: function(d) { return "تتوفّر خدمة العملاء على مدار 24 ساعة"; },
    customerCareDetails: function(d) { return "فريقنا هنا ليساعدك بكل شيئ ابتداءً من اختيار المقاس وحتى اختيار التصميم "; },
    callUs: function(d) { return " اتصلوا بنا"; },
    emailUs: function(d) { return " تواصلوا معنا عبر البريد الإلكتروني"; },
    returns: function(d) { return "إرجاع المشتريات بسهولة"; },
    returnsDetails: function(d) { return "في حال لم يكن طلبك صحيحًا، فإن عملية الإرجاع سهلة جدّا"; },
    returnsLink: function(d) { return " اكتشاف المزيد"; },
    delivery: function(d) { return "خدمة التوصيل حول العالم"; },
    deliveryDetails: function(d) { return "نوصل إلى أكثر من 100 موقع "; },
    deliveryLink: function(d) { return "عرض خيارات التوصيل"; }
  },
  months: {
    january: function(d) { return "يناير"; },
    february: function(d) { return "فبراير"; },
    march: function(d) { return "مارس"; },
    april: function(d) { return "أبريل"; },
    may: function(d) { return "مايو"; },
    june: function(d) { return "يونيو"; },
    july: function(d) { return "يوليو"; },
    august: function(d) { return "أغسطس"; },
    september: function(d) { return "سبتمبر"; },
    october: function(d) { return "أكتوبر"; },
    november: function(d) { return "نوفمبر"; },
    december: function(d) { return "ديسمبر"; }
  },
  errors: {
    maxLength: function(d) { return "يجب أن يتكون من (أحرف) أحرف أو أقل"; },
    minLength: function(d) { return "يجب أن يتكون من (أحرف) أحرف أو أكثر"; },
    containsWhitespace: function(d) { return "يحتوي على مسافة بيضاء"; },
    characterOccurrence: function(d) { return "ينبغي أن لا يُستخدم الحرف أكثر من " + d.occurrence + " مرات عند إنشاء كلمة المرور."; },
    characterRepeats: function(d) { return "يجب ألّا تحتوي كلمة المرور على أكثر من " + d.repeats + " أحرف متتالية"; },
    containsLogonId: function(d) { return "ينبغي أن لا تحتوي كلمة المرور على اسم المستخدم"; },
    containsPassword: function(d) { return "ينبغي أن لا تحتوي كلمة المرور على كلمة \"password\""; },
    invalid: function(d) { return "تم ادخال معلومات غير صحيحة"; },
    invalidField: function(d) { return "يرجى التحقق من الحقل لتتبع إدخال أحرف غير صحيحة"; },
    required: function(d) { return " مطلوب"; },
    invalidZipCode: function(d) { return select(d.country, { US: "رمز بريدي غير صالح", other: "رقم بريدي غير صالح" }); },
    invalidState: function(d) { return "ولاية غير صحيحة"; },
    invalidDob: function(d) { return "يُرجى إخال تاريخ ميلادك في النموذج (DD/MM/YYYY)"; },
    generic: function(d) { return "نأسف، حدث خطأ ما. يرجى المحاولة لاحقًا."; },
    fieldErrors: function(d) { return "يرجى التحقق من المعلومات التالية مرة أخرى:"; },
    global: function(d) { return "هناك مشكلة. يرجى المحاولة لاحقًا."; },
    authenticationError: function(d) { return "اسم المستخدم أو كلمة المرور المحددين غير صحيحين"; },
    loginNotAllowed: function(d) { return "يجب عليك الانتظار " + d.time + "  " + d.timeUnit + "قبل تمكنك من تسجيل الدخول مرة أخرى."; },
    timeUnit: function(d) { return select(d.type, { HOUR: "ساعة", HOURS: "ساعات", MINUTES: "دقائق", SECONDS: "ثنواني", other: "" }); },
    userExists: function(d) { return "تم تسجيل المستخدم مسبقًا"; },
    passwordsDontMatch: function(d) { return " كلمات السر غير متطابقة "; },
    phoneRequired: function(d) { return "مطلوب رقم هاتفك المحمول لتلقي رسائل نصية حول  تحديثات حالة الطلب من خدمة التوصيل لدى The Outnet"; },
    mustContainNumber: function(d) { return "يجب أن تحتوي كلمة المرور على الأقل " + plural(d.occurrence, 0, en, { one: "حرف واحد", other: number(d.occurrence, "occurrence") + "أرقام" }); },
    mustContainLetter: function(d) { return "Your password must contain at least " + plural(d.occurrence, 0, en, { one: "one letter", other: number(d.occurrence, "occurrence") + " letters" }); },
    mustContainUppercase: function(d) { return "يجب أن تشمل كلمة المرور الخاصة بك على الأقل حرفًا واحدًا من الحروف الكبيرة."; },
    passwordsMatch: function(d) { return "يجب أن تكون كلمة المرور الجديدة مختلفة عن كلمة المرور التي استخدمتها سابقا"; },
    reuseOldPassword: function(d) { return " كلمة المرور التي قمتم بإدخالها قد تم استخدامها مسبقًا. يُرجى إدخال كلمة المرور الجديدة"; },
    expiredValidationCode: function(d) { return "عذرًا ، انتهت صلاحية رمز التحقق"; },
    invalidValidationCode: function(d) { return "يرجى محاولة إعادة تعيين كلمة المرور الخاصة بكِ مرة أخرى"; },
    blocklistedPassword: function(d) { return "عذراً، لا يمكنك استخدام كلمة المرور هذه"; },
    updateNotAllowed: function(d) { return "يجب عليك الانتظار " + d.timeToWait + " ساعات قبل المحاولة مرة أخرى"; },
    goBack: function(d) { return "الرجوع"; },
    pcccRequired: function(d) { return "أدخل رقم PCCC الخاص بك مثال ( P+ اثنا عشر مدخلة)"; },
    swiftCode: function(d) { return "يجب أن يكون رمز SWIFT بين 8 و 11 حرفًا"; },
    ibanCode: function(d) { return "يجب أن يتكون رمز IBAN الخاص بك من 35 حرفًا وأن يحتوي على أحرف أبجدية رقمية فقط"; },
    returnError: function(d) { return "نعتذر، لم نتمكن من إكمال طلب الإرجاع الخاص بك. يُرجى المحاولة مُجددًا أو التواصل مع قسم رعاية العملاء"; },
    exchangeError: function(d) { return "نعتذر، لم نتمكن من إكمال طلب التبديل الخاص بك. يُرجى المحاولة مُجددًا أو التواصل مع قسم رعاية العملاء"; },
    duplicateReturnError: function(d) { return "يبدو أنك قُمت بإعداد طلب إرجاع لهذه الطلبية مُسبقًا. لإجراء أيّ تعديلات، يُرجى التواصل مع مركز رعاية العملاء"; },
    invalidOrderItem: function(d) { return "نعتذر، هذا العنصر لا يُمكن إرجاعه."; },
    invalidOrder: function(d) { return "نعتذر، هذه الطلبية لا يُمكن إرجاعها"; },
    invalidCharacters: function(d) { return "عذراً، لا يمكننا القبول حاليّا " + d.nonLatin; },
    meetRequirements: function(d) { return "يُرجى التأكد من أن كلمة المرور التي قمتم باستخدامها   تتوافق مع المتطلبات المذكورة أعلاه"; },
    zipCodeDoesNotMatchState: function(d) { return " يُرجى التأكد من " + d.zip + " الخاص بكم"; },
    refundPaymentMethod: function(d) { return "يُرجى اختيار طريقة استرداد المبلغ"; },
    changeCountryNotAllowedError: function(d) { return " تم شحن هذا الطلب إلى بلد/ منطقة مختلفة. للقيام بطلب الاستبدال أو الإرجاع ، يرجى تعديل موقعكم ليطابق الموقع الذي اشتريتم منه والمحاولة مرة أخرى"; },
    eircode: function(d) { return "Must be a 7-character alpha-numeric code, e.g. A65 F4E2. For information visit www.eircode.ie"; }
  },
  retry: {
    title: function(d) { return "عذرًا، هذه الصفحة غير متاحة."; },
    retrynow: function(d) { return " يُرجى المحاولة مرّة أخرى الآن"; },
    timetoretry: function(d) { return "سنحاول إعادة الاتصال بك في " + d.seconds + " ثواني..."; },
    retryingnow: function(d) { return "إعادة المحاولة الآن"; }
  },
  totals: {
    itemTotal: function(d) { return "إجمالي مبلغ القطع"; },
    shipping: function(d) { return "الشحن"; },
    shippingPrice: function(d) { return select(d.isFree, { true: "مجانًا", other: d.price }); },
    packaging: function(d) { return "التغليف"; },
    total: function(d) { return "المجموع"; },
    remove: function(d) { return "حذف "; },
    tax: function(d) { return "الضرائب"; },
    duty: function(d) { return "رسوم"; }
  },
  personalInfoForm: {
    personTitle: function(d) { return "اللقب"; },
    firstName: function(d) { return "الاسم الأول"; },
    lastName: function(d) { return "اسم العائلة"; },
    dob: function(d) { return "تاريخ الميلاد (اختياري)"; },
    submit: function(d) { return "تحديث"; },
    dayPlaceholder: function(d) { return "الشهر"; },
    monthPlaceholder: function(d) { return "الشهر"; },
    yearPlaceholder: function(d) { return "السنة"; },
    other: function(d) { return "أخرى"; },
    selectTitle: function(d) { return "اختر اللقب"; },
    dobHelp: function(d) { return ""; },
    day: function(d) { return "يوم"; },
    month: function(d) { return "شهر"; },
    year: function(d) { return "سنة"; }
  },
  greetings: {
    morning: function(d) { return "صباح الخير، " + d.firstName; },
    afternoon: function(d) { return "طاب مساؤك، " + d.firstName; },
    evening: function(d) { return "مساء الخير، " + d.firstName; }
  },
  product: {
    infoUnavailable: function(d) { return "تعذّر استرداد جميع معلومات المنتج حاليًا. يُرجى التحقق من رسالة البريد الإلكتروني الخاصة بالتأكيد على الطلبية للاطلاع على كامل التفاصيل."; }
  },
  help: {
    passwordRules: function(d) { return "يجب أن تتكون كلمة المرور من ثمانية حروف أو أكثر وأن تحتوي على حرف كبير ورقم"; }
  },
  loginAdditionalMessages: {
    addToWishlist: {
      message: function(d) { return "لحفظ هذا المنتج في قائمة أمنياتك، يُرجى التسجيل كمستخدم جديد أو تسجيل الدخول"; }
    },
    restrictedPage: {
      message: function(d) { return "احصلوا على فرصة استخدام التطبيق بمجرد تسجيل الدخول من حسابكم الخاص"; }
    }
  },
  referrals: {
    title: function(d) { return " اذكروا صديقًا"; },
    landingTitle: function(d) { return "أهلاً بكم في THE OUTNET"; },
    error: function(d) { return "نعتذر، حدث خطئ أثناء تحميل هذه الصفحة"; },
    errorAction: function(d) { return "الرجوع"; },
    cookieMessage: function(d) { return "Oops! Your browser isn't accepting cookies. Please enable your cookies to view this page."; }
  },
  cod: {
    refund: function(d) { return "أثناء تقديم هذا الطلب باستخدام خدمة الدفع النقدي عند التسليم، نحتاج إلى أخذ التفاصيل المصرفية الخاصة بك حتى نتمكن من استرداد أموالك."; },
    bankNameFieldName: function(d) { return "اسم البنك"; },
    accountNameFieldName: function(d) { return "اسم مالك الحساب"; },
    swiftCodeFieldName: function(d) { return "رمز BIC / SWIFT"; },
    accountNoFieldName: function(d) { return "رمز IBAN"; }
  },
  credits: {
    brand: function(d) { return ""; },
    remainingCredit: function(d) { return "الرصيد المتبقي"; },
    transactions: function(d) { return "المعاملات"; },
    error: function(d) { return "نعتذر، لم يتم العثور على تفاصيل رصيدك في المتجر"; },
    title: function(d) { return "Store Credit"; },
    noStoreCredit: function(d) { return "ليس لديك رصيد متوفر في المتجر"; },
    allTransactions: function(d) { return "جميع المعاملات"; },
    viewAll: function(d) { return "عرض الجميع"; },
    subheading: function(d) { return "رصيدك ومن معاملاتك"; },
    closeTransactions: function(d) { return "إغلاق"; }
  },
  giftcards: {
    title: function(d) { return "Gift Cards"; },
    info: function(d) { return "For assistance redeeming a Gift Card, please call Customer Care 24/7 on " + d.countryPhoneLink + "."; },
    noGiftCard: function(d) { return "You have no gift card"; }
  },
  privacy: {
    version: function(d) { return "نسخة " + d.version; },
    read: function(d) { return "لقد قمت بقراءته في تاريخ " + d.consentTime; },
    pageError: function(d) { return "عذراً، حدث خطأ ما، يُرجى إعادة المحاولة"; },
    retryButton: function(d) { return "يُرجى إعادة المحاولة"; }
  },
  privacyCloseAccount: {
    title: function(d) { return "إغلاق الحساب"; },
    confirmationBody: function(d) { return " هل أنتم متأكدون أنكم تريدون إغلاق حسابكم؟"; },
    acknowledgingBodyBp1: function(d) { return "شكراً لكِ على تقديم طلبكِ."; },
    acknowledgingBodyBp2: function(d) { return " سنحذف حسابكم وجميع البيانات الشخصية ذات الصلة في أقرب وقتٍ ممكن وسنعلمكم في غضون 30 يوماً."; },
    confirmButton: function(d) { return "إغلاق الحساب"; },
    cancelButton: function(d) { return "إلغاء"; }
  },
  tcOverlay: {
    title: function(d) { return "YOOX NET-A-PORTER Group S.p.A. and The Net-A-Porter Group Limited collect and use your personal information as follows:"; },
    footerBeforeLink: function(d) { return "For further information, please read our "; },
    footerLink: function(d) { return "Privacy Policy"; },
    footerAfterLink: function(d) { return "."; }
  },
  tcParagraphs: {
    pg1: function(d) { return "Purposes of collection and use of personal information: identification of users; verification of eligibility for subscription; prevention of fraudulent subscription and fraud; execution and performance of purchase agreements for products; provision of services provided by the website and the Apps; response to customer requests and inquiries; exercise or defense of legal claims, statistical analysis and survey; and performance of obligations under applicable laws and regulations."; },
    pg2: function(d) { return "Items of Personal Information to be collected."; },
    pg3: function(d) { return "[When signing up for membership] Name, surname, email address, password, service usage history and, if provided by the user, date of birth, gender and phone number."; },
    pg4: function(d) { return "[When purchasing products] Order history, delivery address, invoice address, phone number, payment details."; },
    pg5: function(d) { return "Period of retention and use of personal information: Information collected at the time of membership registration will be retained and used until a request for withdrawal is made, and information collected to conclude and execute a purchase contract for a product will be stored in accordance with applicable tax legislation until the conclusion of all administrative and accounting formalities (ten years)."; }
  },
  newsletterTcParagraphs: {
    pg1: function(d) { return "Purpose of collection and use of personal information: Transmission of newsletters and advertisements, customised promotional and marketing communications to improve user shopping experience."; },
    pg2: function(d) { return "Items of personal information to be collected: Name, email address, gender, date of birth, phone number, order history, browsing habits."; },
    pg3: function(d) { return "Period of retention and use of personal information: To the extent permitted by applicable laws and regulations, personal information will be processed until you withdraw your consent or request your membership withdrawal or, with specific regard to the customisation of the communications, you disable the cookies. Any other information required to be preserved under applicable laws and regulations shall be preserved for the period set forth under such laws and regulations."; }
  }
}